import React, { useState } from 'react';
import { compact } from '@moda/portal-stanchions';
import { Button, Breakpoint, SlidingPane } from '@moda/om';
import { SizeSelectorFragment } from '../../generated/types';
import { getActiveVariantBy } from '../../lib/getActiveVariantBy';
import { BackInStockNotificationForm } from './BackInStockNotificationForm';
import { BackInStockNotificationModal } from './BackInStockNotificationModal';
import './NotifyMeButton.scss';

type Props = {
  activeVariantId: string;
  variant: SizeSelectorFragment;
};

export const NotifyMeButton: React.FC<Props> = ({ variant, activeVariantId }) => {
  const activeVariant = getActiveVariantBy(variant, 'id', activeVariantId);
  const inventory = compact(activeVariant.inventory);

  const [showModal, setShowModal] = useState(false);

  if (inventory.length === 0) return null;

  return (
    <>
      <Button className="NotifyMeButton" onClick={() => setShowModal(true)}>
        Notify Me
      </Button>
      <Breakpoint lt="md">
        <SlidingPane title="Notify Me" visible={showModal} onClose={() => setShowModal(false)}>
          <BackInStockNotificationForm
            activeVariantId={activeVariantId}
            variant={variant}
            size={inventory[0]}
            onClose={() => setShowModal(false)}
          />
        </SlidingPane>
      </Breakpoint>
      <Breakpoint gt="md">
        <BackInStockNotificationModal
          show={showModal}
          activeVariantId={activeVariantId}
          variant={variant}
          size={inventory[0]}
          onClose={() => setShowModal(false)}
        />
      </Breakpoint>
    </>
  );
};
